export type DeviceType = 'desktop' | 'mobile';

interface DeviceInfo {
    browser: string;
    os: string;
    userAgent: string;
    screen: {
        width: number;
        height: number;
    };
}

const DEVICE_ID_KEY = 'hia_device_id';

export const getDeviceId = (): string => {
    let deviceId = localStorage.getItem(DEVICE_ID_KEY);
    if (!deviceId) {
        // Use crypto.randomUUID if available, otherwise fallback to a simple random string
        if (typeof crypto !== 'undefined' && crypto.randomUUID) {
            deviceId = crypto.randomUUID();
        } else {
            deviceId = Math.random().toString(36).substring(2) + Date.now().toString(36);
        }
        localStorage.setItem(DEVICE_ID_KEY, deviceId);
    }
    return deviceId;
};

export const getDeviceType = (): DeviceType => {
    const ua = navigator.userAgent;
    const isMobile = /iPhone|iPad|iPod|Android/i.test(ua);
    const isTablet = /iPad|Android/i.test(ua) && window.innerWidth > 768;

    // Tablets are treated as mobile for touch consistency, 
    // but this can be adjusted based on UX preference.
    // For now, following the proposal: Tablet = Mobile.
    if (isMobile || isTablet) {
        return 'mobile';
    }
    return 'desktop';
};

export const getDeviceInfo = (): DeviceInfo => {
    const ua = navigator.userAgent;
    let browser = 'Unknown';
    let os = 'Unknown';

    if (ua.indexOf('Firefox') > -1) {
        browser = 'Firefox';
    } else if (ua.indexOf('SamsungBrowser') > -1) {
        browser = 'Samsung Internet';
    } else if (ua.indexOf('Opera') > -1 || ua.indexOf('OPR') > -1) {
        browser = 'Opera';
    } else if (ua.indexOf('Trident') > -1) {
        browser = 'Internet Explorer';
    } else if (ua.indexOf('Edge') > -1) {
        browser = 'Edge';
    } else if (ua.indexOf('Chrome') > -1) {
        browser = 'Chrome';
    } else if (ua.indexOf('Safari') > -1) {
        browser = 'Safari';
    }

    if (ua.indexOf('Win') > -1) os = 'Windows';
    else if (ua.indexOf('Mac') > -1) os = 'MacOS';
    else if (ua.indexOf('Linux') > -1) os = 'Linux';
    else if (ua.indexOf('Android') > -1) os = 'Android';
    else if (ua.indexOf('like Mac') > -1) os = 'iOS';

    return {
        browser,
        os,
        userAgent: ua,
        screen: {
            width: window.innerWidth,
            height: window.innerHeight
        }
    };
};

/**
 * Reseta o device ID (útil para testes ou logout)
 */
export const resetDeviceId = (): void => {
    localStorage.removeItem(DEVICE_ID_KEY);
};

/**
 * Verifica se uma mensagem veio deste dispositivo
 */
export const isFromThisDevice = (messageDeviceId: string): boolean => {
    return messageDeviceId === getDeviceId();
};
